var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductCatalogue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 8H10M6 12H14M6 16H14M13.9995 1V4M5.99951 1V4M5 2.5H15C17.2091 2.5 19 4.29086 19 6.5V17C19 19.2091 17.2091 21 15 21H5C2.79086 21 1 19.2091 1 17V6.5C1 4.29086 2.79086 2.5 5 2.5Z",
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductCatalogue);
export default __webpack_public_path__ + "static/media/productCatalogue.864e8e33727e0a115ee91cba5947150d.svg";
export { ForwardRef as ReactComponent };